import React from 'react';
import MapItemSelector from '../Map/MapItemSelector';
import TokenIcon from '../Icons/TokenIcon';
import TokenCreator from './TokenCreator';

const TokenSelector = () => {

    const button = (
        <>
            <div className="pl-4 pr-4">
                <TokenIcon className="w-12 h-12" />
            </div>
        </>
    );

    const popup = (
        <div>
            <div className="bg-mid-blue pl-4 pt-4 pb-4 pr-2 gap-2 rounded-2xl flex align-center">
                <TokenCreator />
            </div>
        </div>
    );

    return (
        <MapItemSelector
            button={button}
            popup={popup}
            id="token-selector"
        />
    );
};

export default TokenSelector;

